import { api } from 'utility';
import { getFileUrl , getDownloadableFile } from 'URLs';
export function getFile(hashCode) {
  return api.get(getFileUrl() + `/${hashCode}`, { responseType: 'blob' }).then((res) => res);
}
export function getDownloadableFileUrl(id) {
  return api.get(getDownloadableFile(id)).then((res) => res.data);
}
export default {
  getFile,
  getDownloadableFileUrl
};
